import React, { useState } from "react";
import axios from "axios";
import { Button, Card, Field } from "../components/UI";
import { useToast } from "../hooks";

const channels = [
  { name: "Hostaway", value: "hostaway" },
  { name: "Ownerrez", value: "ownerrez" },
  { name: "Trustd", value: "trustd" },
];

function generateRandomString(length) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

export default function InvitationCode() {
  const [invitationCode, setInvitationCode] = useState("");
  const [selectedChannel, setSelectedChannel] = useState("");
  const [description, setDescription] = useState("");
  const [notes, setNotes] = useState("");
  const [password, setPassword] = useState("");
  const [isCreating, setIsCreating] = useState(false);
  const addToast = useToast();

  const createCode = async () => {
    if (isCreating) return;
    if (!invitationCode || !selectedChannel || !password) {
      addToast({ severity: "error", summary: "Validation Error", detail: "Invitation code, channel and password are required.", life: 5000 });
      return;
    }
    try {
      setIsCreating(true);
      await axios.post("/v1/integrations/tpc/api/invitation-code/create", {
        code: invitationCode,
        channel: selectedChannel,
        notes,
        description,
        password,
      });

      addToast({ severity: "success", summary: "Success", detail: "Invitation Code Created Succesfully!", life: 5000 });
    } catch (error) {
      addToast({ severity: "error", summary: "Error", detail: "Incorrect password!", life: 10000 });
    } finally {
      setIsCreating(false);
    }
  };

  const onEnter = (event) => {
    if (event.key === "Enter") {
      createCode();
    }
  };

  return (
    <div className="invitation-code-page account-page-modern account-form-page">
      <Card className="account-form-card account-form-card-wide invitation-code-card">
        <div className="account-form-head">
          <p className="dashboard-section-kicker">Admin Access</p>
          <h2>Create Invitation Code</h2>
        </div>

        <div className="account-form-grid">
          <Field
            label={
              <span className="invitation-code-label">
                Invitation Code
                <button
                  type="button"
                  className="dice-link"
                  onClick={() => setInvitationCode(generateRandomString(16))}
                >
                  Generate
                </button>
              </span>
            }
            required
          >
            <input
              type="text"
              className="form-control"
              placeholder="Invitation Code"
              value={invitationCode}
              autoCapitalize="characters"
              spellCheck="false"
              onKeyDown={onEnter}
              onChange={(event) => setInvitationCode(event.target.value)}
            />
          </Field>
          <Field label="Channel" required>
            <select
              className="form-control form-select"
              value={selectedChannel}
              onChange={(event) => setSelectedChannel(event.target.value)}
            >
              <option value="">Select a Channel</option>
              {channels.map((channel) => (
                <option key={channel.value} value={channel.value}>
                  {channel.name}
                </option>
              ))}
            </select>
          </Field>
          <Field label="Description">
            <input
              type="text"
              className="form-control"
              placeholder="Description"
              value={description}
              onKeyDown={onEnter}
              onChange={(event) => setDescription(event.target.value)}
            />
          </Field>
          <Field label="Notes">
            <input
              type="text"
              className="form-control"
              placeholder="Notes"
              value={notes}
              onKeyDown={onEnter}
              onChange={(event) => setNotes(event.target.value)}
            />
          </Field>
          <Field label="Password" required>
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              value={password}
              autoComplete="current-password"
              onKeyDown={onEnter}
              onChange={(event) => setPassword(event.target.value)}
            />
          </Field>
        </div>

        <div className="account-form-actions">
          <Button
            label={isCreating ? "Creating..." : "Create Code"}
            disabled={isCreating}
            onClick={createCode}
          />
        </div>
      </Card>
    </div>
  );
}
